import React from 'react';
type SectionHeadingProps = {
  title: React.ReactNode;
  subtitle?: string;
  align?: 'center' | 'left';
};
export function SectionHeading({
  title,
  subtitle,
  align = 'center'
}: SectionHeadingProps) {
  const centered = align === 'center';
  return <div className={centered ? 'text-center' : 'text-left'} data-id="element-64" data-mp="3f36q7i3iln6m">
      <div className={`h-px w-12 bg-rose ${centered ? 'mx-auto' : ''}`} aria-hidden="true" data-id="element-65" data-mp="3k185rt1qf4dc" />
      <h2 className={`mt-6 max-w-4xl font-serif text-3xl uppercase leading-[1.15] text-ink md:text-5xl ${centered ? 'mx-auto' : ''}`} data-id="element-66" data-mp="bk3q5rowh9bi">{title}</h2>
      {subtitle && <p className={`mt-6 max-w-3xl text-lg leading-relaxed text-ink-muted md:text-xl ${centered ? 'mx-auto' : ''}`} data-id="element-67" data-mp="glaz3u2s4ejr">{subtitle}</p>}
    </div>;
}